export const videoLinks = {
  en:	'rocketman-help-en.mp4',
  ar:	'rocketman-help-ar.mp4',
  bg:	'rocketman-help-bg.mp4',
  de:	'rocketman-help-de.mp4',
  el:	'rocketman-help-el.mp4',
  es:	'rocketman-help-es.mp4',
  fr:	'rocketman-help-fr.mp4',
  he:	'rocketman-help-he.mp4',
  hr:	'rocketman-help-hr.mp4',
  hu:	'rocketman-help-hu.mp4',
  it:	'rocketman-help-it.mp4',
  mk:	'rocketman-help-mk.mp4',
  pl:	'rocketman-help-pl.mp4',
  pt:	'rocketman-help-pt.mp4',
  ro:	'rocketman-help-ro.mp4',
  sr:	'rocketman-help-rs.mp4',
  rs:	'rocketman-help-rs.mp4',
  ru:	'rocketman-help-ru.mp4',
  sq:	'rocketman-help-sq.mp4',
  sv:	'rocketman-help-sv.mp4',
  tr:	'rocketman-help-tr.mp4',
  uk:	'rocketman-help-uk.mp4',
  zh: 'rocketman-help-zh.mp4',
  xe: 'rocketman-help-xe.mp4'
}
